const DEFAULT_TIMEOUT_MS = 1000;
export const FAILSAFE_BUFFER_MS = 500;

export function requestBidsAndSetTargeting({
  adUnits = [],
  timeoutMs = DEFAULT_TIMEOUT_MS,
  adUnitCodes = adUnits.map(adUnit => adUnit.code),
  registerAdUnits = true,
} = {}) {
  if (typeof window === 'undefined') {
    return Promise.resolve(false);
  }

  const pbjs = window.pbjs;
  if (!pbjs || !adUnitCodes.length) {
    return Promise.resolve(false);
  }

  pbjs.que = pbjs.que || [];

  return new Promise(resolve => {
    let settled = false;
    let failsafeTimer;
    const finish = result => {
      if (!settled) {
        settled = true;
        clearTimeout(failsafeTimer);
        resolve(result);
      }
    };
    failsafeTimer = setTimeout(() => finish(false), timeoutMs + FAILSAFE_BUFFER_MS);

    pbjs.que.push(() => {
      if (settled) {
        return;
      }

      try {
        if (
          typeof pbjs.addAdUnits !== 'function' ||
          typeof pbjs.requestBids !== 'function' ||
          typeof pbjs.setTargetingForGPTAsync !== 'function'
        ) {
          finish(false);
          return;
        }

        if (registerAdUnits && adUnits.length) {
          pbjs.addAdUnits(adUnits);
        }

        pbjs.requestBids({
          adUnitCodes,
          timeout: timeoutMs,
          bidsBackHandler: () => {
            try {
              pbjs.setTargetingForGPTAsync(adUnitCodes);
              finish(true);
            } catch {
              finish(false);
            }
          },
        });
      } catch {
        finish(false);
      }
    });
  });
}
